import React from "react";
import ButtonIcon, {ButtonType} from "../../atoms/button/buttonIcon";
import {IconSource} from "../../../shared/enums/iconSource";
import {useTranslation} from "react-i18next";

export interface IFilePickerProps {
  onFilePicked: (file: File) => void;
  type?: ButtonType;
  icon?: IconSource;
  text?: string;
  acceptedFileTypes?: string;
  isValid?: boolean;
  isDisabled?: boolean;
}

const FilePicker: React.FC<IFilePickerProps> = ({
  onFilePicked,
  type = "accessory",
  icon = IconSource.image,
  text,
  acceptedFileTypes = "image/*",
  isValid = true,
  isDisabled = false
}) => {
  const {t} = useTranslation(["translation"]);
  const buttonText = text ?? t("translation:controls.image.chooseImageButton");

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length) {
      onFilePicked(event.target.files[0]);
    }

    // We want the onChange to trigger, even if the user selects the same file twice.
    // We must clear the value.
    event.target.value = "";
    event.preventDefault();
  };

  return (
    <>
      <input
        data-testid={"file-input"}
        type="file"
        ref={inputRef}
        onChange={handleChange}
        accept={acceptedFileTypes}
        style={{display: "none"}}
      />
      <ButtonIcon
        isValid={isValid}
        type={type}
        icon={icon}
        isDisabled={isDisabled}
        onClick={() => inputRef.current?.click()}
      >
        {buttonText}
      </ButtonIcon>
    </>
  );
};

export default FilePicker;
